import { useState } from "react";
import * as XLSX from "xlsx";

const API_URL = "https://appcorp.parma.com.gt/apipp/ReceptorDatos";

const TOKEN =
  "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY";

function toNumber(value) {
  if (value === null || value === undefined || value === "") return 0;
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

function mapExcelRows(rows) {
  return rows
    .filter((row) => row["ID Producto"])
    .map((row) => ({
      CuartoFrio: String(row["Cuarto Frío"] ?? ""),
      ItemCode: String(row["ID Producto"] ?? ""),
      ItemName: String(row["Producto"] ?? ""),
      DeptoProd: String(row["Depto. Prod."] ?? ""),

      CoberturaOriginal: toNumber(row["Cobertura"]),
      InventarioDguaOriginal: toNumber(row["Inventario DGUA"]),

      CoberturaCalculada: toNumber(row["Cobertura CALCULADA "]),
      InventarioDguaCalculado: toNumber(row["Inventario DGUA_1"]),

      ConsumoDia: toNumber(row["Consumo por día"]),
      Fisico: toNumber(row["Físico"]),
      Abasto: toNumber(row["Abasto"]),
      Trans: toNumber(row["Trans"]),
      PedidoDgua: toNumber(row["Pedido DGUA"]),
      PedidoSalas: toNumber(row["Pedido Salas"]),
      FacNor: toNumber(row["Fac. Nor."]),
      FacRes: toNumber(row["Fac. Res."]),
      OvsProgr: toNumber(row["Ovs Progr"]),
      SapOv: toNumber(row["SAP OV"]),
    }));
}

export default function CargarPedidoDgua() {
  const [envUniquecode, setEnvUniquecode] = useState("");
  const [usuario, setUsuario] = useState("OPERADOR01");
  const [detalle, setDetalle] = useState([]);
  const [estado, setEstado] = useState("");
  const [respuesta, setRespuesta] = useState(null);

  async function handleFile(event) {
    const file = event.target.files?.[0];
    if (!file) return;

    setEstado("Leyendo Excel...");

    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer, { type: "array" });

    const sheet =
      workbook.Sheets["Hoja2"] || workbook.Sheets[workbook.SheetNames[0]];

    const rows = XLSX.utils.sheet_to_json(sheet, {
      range: 2,
      defval: "",
    });

    const mapped = mapExcelRows(rows);

    setDetalle(mapped);
    setEstado(`Archivo cargado: ${mapped.length} productos`);
  }

  async function subirCorte() {
    try {
      if (!envUniquecode.trim()) {
        setEstado("Ingresa el código del envío");
        return;
      }

      if (detalle.length === 0) {
        setEstado("Primero carga el Excel");
        return;
      }

      setEstado("Subiendo corte...");

      const datosRecibidos = {
        Tabla: "cps_pedidos_dgua",
        TipoOperacion: "InsertCorteExcel",
        PED_ENV_UNIQUECODE: envUniquecode.trim(),
        PED_USUARIO_CREACION: usuario.trim() || "OPERADOR01",
        PED_CLIENTE_DESTINO: "DGUA",
        PED_DIAS_PROYECCION: 15,
        PED_OBSERVACIONES: "Corte cargado desde Excel",
        JsonDetalle: detalle,
      };

      const body = {
        Token: TOKEN,
        Ambiente: "DESA",
        Dispositivo: {
          Marca: "WEB",
          Modelo: "React",
          Version: "1.0",
          McAdress: null,
          PowerStatus: "100%",
          WifiStatus: "ONLINE",
          GPSStatus: "OFF",
          GPS: "",
        },
        User: {
          Codigo: "",
          UserNickName: usuario.trim() || "OPERADOR01",
        },
        Metodo: {
          NombreMetodo: "CRUDPesajeCajillas",
          Datos_Recibidos: JSON.stringify(datosRecibidos),
          Datos_Generados: "",
        },
        Datos: null,
      };

      console.log("REQUEST BODY:", body);

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      console.log("API RESPONSE:", data);
      setRespuesta(data);

      if (!response.ok) {
        setEstado(`Error HTTP: ${response.status}`);
        return;
      }

      setEstado("Corte subido correctamente");
    } catch (error) {
      console.error(error);
      setEstado(`Error: ${error.message}`);
    }
  }

  return (
    <div style={{ padding: 24, maxWidth: 1000 }}>
      <h2>Cargar Pedido DGUA</h2>

      <div style={{ marginBottom: 12 }}>
        <label>
          Envío
          <input
            value={envUniquecode}
            onChange={(e) => setEnvUniquecode(e.target.value)}
            placeholder="ENV-20260617-001"
            style={{
              display: "block",
              width: "100%",
              padding: 8,
              marginTop: 4,
            }}
          />
        </label>
      </div>

      <div style={{ marginBottom: 12 }}>
        <label>
          Usuario
          <input
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            style={{
              display: "block",
              width: "100%",
              padding: 8,
              marginTop: 4,
            }}
          />
        </label>
      </div>

      <div style={{ marginBottom: 16 }}>
        <input type="file" accept=".xlsx,.xls" onChange={handleFile} />
      </div>

      <button onClick={subirCorte} disabled={detalle.length === 0}>
        Subir corte DGUA
      </button>

      <p style={{ marginTop: 16 }}>{estado}</p>

      {detalle.length > 0 && (
        <>
          <h3>Vista previa</h3>
          <table border="1" cellPadding="6" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>PTPR</th>
                <th>Producto</th>
                <th>Depto</th>
                <th>Cobertura</th>
                <th>Pedido DGUA</th>
              </tr>
            </thead>
            <tbody>
              {detalle.slice(0, 25).map((item, index) => (
                <tr key={`${item.ItemCode}-${index}`}>
                  <td>{item.ItemCode}</td>
                  <td>{item.ItemName}</td>
                  <td>{item.DeptoProd}</td>
                  <td>{item.CoberturaCalculada}</td>
                  <td>{item.PedidoDgua}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {respuesta && (
        <>
          <h3>Respuesta API</h3>
          <pre
            style={{
              background: "#f4f4f4",
              padding: 12,
              whiteSpace: "pre-wrap",
            }}
          >
            {JSON.stringify(respuesta, null, 2)}
          </pre>
        </>
      )}
    </div>
  );
}